import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function DeschideHero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-brand-cream" data-id="element-1070">
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-brand-gold/[0.08] to-brand-purple/[0.05] rounded-full blur-3xl -translate-x-1/2 -translate-y-1/4 animate-float pointer-events-none" data-id="element-1071" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-1072">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-8 gap-x-12 lg:gap-20 lg:items-center" data-id="element-1073">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="order-1 lg:order-1 lg:col-start-1 lg:row-start-1 max-w-2xl flex flex-col items-center text-center" data-id="element-1074">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-brand-gold/20 text-brand-gold text-sm font-medium mb-8 shadow-sm" data-id="element-1075">
              <Sparkles className="w-4 h-4" data-id="element-1076" />
              Academia de Abundență
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-[72px] leading-[1.1] font-bold text-brand-text mb-6 text-balance" data-id="element-1077">
              Deschide-ți Larg Brațele către Abundență
            </h1>

            <p className="font-subtitle font-medium text-xl md:text-2xl text-brand-textSec leading-relaxed text-balance" data-id="element-1078">
              Abundența nu e doar despre bani. E despre a avea din plin:
              sănătate, relații, liniște și împlinire.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="order-2 lg:order-2 lg:col-start-2 lg:row-start-1 lg:row-span-2 relative w-full aspect-[4/5] max-w-[420px] mx-auto lg:ml-auto" data-id="element-1079">
            <div className="absolute inset-0 bg-brand-gold/30 rounded-[32px] blur-2xl transform translate-x-4 translate-y-4" data-id="element-1080" />
            <div className="absolute -top-12 -right-12 w-48 h-48 border-[1.5px] border-brand-gold/40 rounded-full border-b-transparent border-l-transparent rotate-45 -z-10" data-id="element-1081" />

            <div className="relative w-full h-full rounded-[32px] shadow-warm overflow-hidden border-4 border-white" data-id="element-1082">
              <img src="https://cdn.magicpatterns.com/uploads/1rkWgruLABLbiu4kcbCtdt/73.png" alt="Adrian Huniade - Deschide-ți Brațele către Abundență" className="w-full h-full object-cover object-top" data-id="element-1083" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} className="order-3 lg:order-3 lg:col-start-1 lg:row-start-2 max-w-2xl flex flex-col items-center text-center" data-id="element-1084">
            <CTAButton limitText="*Curs digital, cu acces instant" data-id="element-1085" />
          </motion.div>
        </div>
      </div>
    </section>;
}